// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin: 0;
  padding: 0;
  text-decoration: none;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
}

body > iframe {
  display: none !important;
}

#root {

  /* Oficial */
  /* background: linear-gradient(to right, rgb(5, 117, 230), rgb(21, 56, 100)); */
background-image: linear-gradient(to right top, #213764, #006291, #008e9a, #00b57f, #9dd354);
}

.home {
  min-height: calc(100vh - 43px);
  background-image: linear-gradient(to right top, #213764, #006291, #008e9a, #00b57f, #9dd354);
  
  /* Oficial */
  /* background: linear-gradient(to right, rgb(5, 117, 230), rgb(21, 56, 100)); */
}

.desconectado {
  min-height: calc(100vh - 43px);
  background-image: linear-gradient(to right top, #213764, #006291, #008e9a, #00b57f, #9dd354);

  /* Oficial */
  /* background: linear-gradient(to right, rgb(5, 117, 230), rgb(21, 56, 100)); */
  text-align: center;
  justify-content: center;
  color: white;
}

.desconectado p {
  font-size: 38px;
  margin-top: 20px;
}

.home {
  min-height: calc(100vh - 43px);
  background-color: #0d1d4c;
}

.pagenotfound {
  min-height: calc(100vh - 43px);
}

.pagenotfound p {
  text-align: center;
  font-size: 2.8rem;
  color: white;
  padding-top: 45vh;
}


h1, h2, h3, h4, h5, h6 {
  color: #213764;
}

.container {
  display: flex;
  margin-bottom: 40px;
  padding-top: 120px;
}

.menu_items_container {
  position: fixed;
  top: 35%;
}

.footer_container {
  min-height: 30px;
  padding-top: 10px;
  position: fixed;
  min-width: 100%;
  bottom: 0;
  left: 0;
  justify-content: center;
  display: flex;
  border-top: 3px solid #9dd354;
  color: #fff;
  font-weight: 500;
  z-index: 3;
  /* background: linear-gradient(360deg, hsla(86, 59%, 58%, 1) 0%, hsla(220, 50%, 26%, 1) 100%); */
  /* background-image: linear-gradient(180deg, #213764, #006291, #008e9a, #00b57f, #9dd354); */

  background: linear-gradient(to top, rgb(5, 117, 230), rgb(21, 56, 100));
}

.footer_container a {
  text-decoration: underline;
  color: white;
}

main{
  width: 100%;
  margin-top: 40px;
}

.sidebar{
  color: white;
  height: 100vh;
  width: 338px;
  transition: all 0.3s;
  margin-right: 22px;
}

.top_section{
  display: flex;
  align-items: center;
  padding: 20px 15px;
}

.logo{
  font-size: 30px;
}

.bars{
  display: flex;
  font-size: 25px;
  margin-left: 50px;
}

.active {
  background-color: #6efdd2;
  color: #212a35;
  border-radius: 20px;
  font-size: 27px;
}

.icon, font-text {
  font-size: 30px;
}

.logoImg {
  width: 50px;
}


input[type="search"] {
  border-radius: 20%;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid #c2bfbf;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
}

.menu__diretoria > li {
  justify-content: center !important;
}

.menu__diretoria > a {
  justify-content: center !important;
}

/* Upload Axios */
.axiosUpload input {
  max-width: 80%;
  height: 30px;
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 5px;
  font-size: 18px;
}

.axiosUpload input[type=file] {
  color: black;
}

.axiosUpload input[type=file]::file-selector-button {
  width: 200px;
  margin-right: 20px;
  border: none;
  background: #084cdf;
  padding: 10px 20px;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  transition: background .2s ease-in-out;
}

#avatar {
  border-radius: 5px;
  margin:  auto; 
  border: none;
  max-width: 50%;
}

#btnUpload {
  width: 200px;
  height: 35px;
  border-radius: 5px;
  background-color: #1859db;
  color: white;
  margin-top: 10px;
  margin-bottom: 10px;
}

.banner {
  position: relative;
  max-width: 800px;
  width: 100%;
  height: 200px;
  background-image: url("https://www.shutterstock.com/image-photo/portrait-happy-business-people-digital-600w-2245070915.jpg"); 
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right center;
  overflow: hidden;
  border: 10px solid white;
  margin-top: 30px;
  margin-left: 50px;
  border-radius: 16px;
}

.banner__content {
  --mask: radial-gradient(300px at 100% 59%,#0000 98%,#000);
  -webkit-mask: var(--mask);
          mask: var(--mask);
  background-color: #001a2c;
  color: white;
  width: 800px;
  height: 200px;
}

.banner__inner__content {
  margin-left: 30px;
  padding-top: 20px;
}

.banner__title {
  margin-top: 18px;
  font-size: 23px;
}

.people {
  width: 95%;
  max-width: 900px;
  margin: 0 auto;
}

.cards {
    max-width: 900px;
    align-items: center;
    width: 90%;
    margin-left: 20px !important;
    margin-bottom: 30px !important;
}

.formdeclaration {
  padding-left: 0 !important;
}

.form__logistics {
   width: 77%;
   padding-top: 30px;
   margin-bottom: 30px;
   height: 100%;
}

/* cards people  */
.ag-format-container {
  width: 100%;
  margin: 0 auto;
}

.ag-courses_box {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.ag-courses_item {
  flex-basis: calc(33.33333% - 30px);
  margin: 0 15px 5px;
  overflow: hidden;
  border-radius: 28px;
  min-width: 280px;
  box-shadow: 6px 3px 10px 0px rgba(0,0,0,0.36);
}

.ag-courses-item_link {
  display: block;
  padding: 15px 13px;
  background-color: #003153;
  overflow: hidden;
  position: relative;
  text-align: center;
}

.ag-courses-item_link:hover,
.ag-courses-item_link:hover .ag-courses-item_date {
  text-decoration: none;
  color: #FFF;
}

.ag-courses-item_link:hover .ag-courses-item_bg {
  transform: scale(10);
}

.ag-courses-item_title {
  min-height: 87px;
  overflow: hidden;
  font-weight: bold;
  font-size: 1.3rem;
  color: #FFF;
  z-index: 2;
  position: relative;
}

.ag-courses-item_bg {
  height: 128px;
  width: 128px;
  background-color: #3ecd5e;

  z-index: 1;
  position: absolute;
  top: -75px;
  right: -75px;

  border-radius: 50%;
  transition: all .5s ease;
}

.menu_items_container {
    border-radius: 10px;
    padding-bottom: 30px;
    text-align: center;
    margin-left: 30px;
}

/* banner */

.banner1 {
  position: relative;
  max-width: 800px;
  width: 100%;
  height: 225px;
  overflow: hidden;
  margin-top: 25px;
  margin-left: 80px;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  border-top-right-radius: 16px;
}

.banner__content1 {
  position: relative;
  background-color: #f5f5dc;
  width: 800px;
  height: 300px;
}

.banner__inner__content1 {
  margin-left: -30px;
}

.banner__inner__content1 img {
  width: 500px;
}

.banner__intro1 {
  font-size: 18px;
}

.banner__title1 {
  margin-top: 18px;
  font-size: 23px;
}

.banner__description1 {
  margin-top: 20px;
}

/* navbar */
.Navbar_nav__gsmxT {
  align-items: center;
    background: #fff;
    border-bottom: 3px solid #9dd354;
    box-shadow: 0 5px 15px rgba(0,0,0,.06);
    display: flex;
    justify-content: space-between;
    padding: 10px;
}

small {
  margin-left: 18px;
}

/* Pagina Consulta de Produtos */
.css-5gwxe9-MuiContainer-root {
  padding-bottom: 30px;
}

.css-1dbovja .MuiTextField-root {
  min-width: 100% !important;
}

.css-3be3ve-MuiFormControl-root-MuiTextField-root-MuiDataGrid-toolbarQuickFilter {
  min-width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,wEAAwE;AAC1E;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,+EAA+E;AACjF,4FAA4F;AAC5F;;AAEA;EACE,8BAA8B;EAC9B,4FAA4F;;EAE5F,YAAY;EACZ,+EAA+E;AACjF;;AAEA;EACE,8BAA8B;EAC9B,4FAA4F;;EAE5F,YAAY;EACZ,+EAA+E;EAC/E,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gGAAgG;EAChG,4FAA4F;;EAE5F,uEAAuE;AACzE;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,4HAA4H;EAC5H,4BAA4B;EAC5B,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,yBAAyB;UACjB,iBAAiB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;GACG,UAAU;GACV,iBAAiB;GACjB,mBAAmB;GACnB,YAAY;AACf;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EAGE,aAAa;EAGb,uBAAuB;EAEvB,eAAe;AACjB;;AAEA;EAEE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAGhB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EAGE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;;EAEzB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,YAAY;;EAEZ,kBAAkB;EAIlB,wBAAwB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,sCAAsC;IACtC,aAAa;IACb,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["*{\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;\n}\n\nbody > iframe {\n  display: none !important;\n}\n\n#root {\n\n  /* Oficial */\n  /* background: linear-gradient(to right, rgb(5, 117, 230), rgb(21, 56, 100)); */\nbackground-image: linear-gradient(to right top, #213764, #006291, #008e9a, #00b57f, #9dd354);\n}\n\n.home {\n  min-height: calc(100vh - 43px);\n  background-image: linear-gradient(to right top, #213764, #006291, #008e9a, #00b57f, #9dd354);\n  \n  /* Oficial */\n  /* background: linear-gradient(to right, rgb(5, 117, 230), rgb(21, 56, 100)); */\n}\n\n.desconectado {\n  min-height: calc(100vh - 43px);\n  background-image: linear-gradient(to right top, #213764, #006291, #008e9a, #00b57f, #9dd354);\n\n  /* Oficial */\n  /* background: linear-gradient(to right, rgb(5, 117, 230), rgb(21, 56, 100)); */\n  text-align: center;\n  justify-content: center;\n  color: white;\n}\n\n.desconectado p {\n  font-size: 38px;\n  margin-top: 20px;\n}\n\n.home {\n  min-height: calc(100vh - 43px);\n  background-color: #0d1d4c;\n}\n\n.pagenotfound {\n  min-height: calc(100vh - 43px);\n}\n\n.pagenotfound p {\n  text-align: center;\n  font-size: 2.8rem;\n  color: white;\n  padding-top: 45vh;\n}\n\n\nh1, h2, h3, h4, h5, h6 {\n  color: #213764;\n}\n\n.container {\n  display: flex;\n  margin-bottom: 40px;\n  padding-top: 120px;\n}\n\n.menu_items_container {\n  position: fixed;\n  top: 35%;\n}\n\n.footer_container {\n  min-height: 30px;\n  padding-top: 10px;\n  position: fixed;\n  min-width: 100%;\n  bottom: 0;\n  left: 0;\n  justify-content: center;\n  display: flex;\n  border-top: 3px solid #9dd354;\n  color: #fff;\n  font-weight: 500;\n  z-index: 3;\n  /* background: linear-gradient(360deg, hsla(86, 59%, 58%, 1) 0%, hsla(220, 50%, 26%, 1) 100%); */\n  /* background-image: linear-gradient(180deg, #213764, #006291, #008e9a, #00b57f, #9dd354); */\n\n  background: linear-gradient(to top, rgb(5, 117, 230), rgb(21, 56, 100));\n}\n\n.footer_container a {\n  text-decoration: underline;\n  color: white;\n}\n\nmain{\n  width: 100%;\n  margin-top: 40px;\n}\n\n.sidebar{\n  color: white;\n  height: 100vh;\n  width: 338px;\n  transition: all 0.3s;\n  margin-right: 22px;\n}\n\n.top_section{\n  display: flex;\n  align-items: center;\n  padding: 20px 15px;\n}\n\n.logo{\n  font-size: 30px;\n}\n\n.bars{\n  display: flex;\n  font-size: 25px;\n  margin-left: 50px;\n}\n\n.active {\n  background-color: #6efdd2;\n  color: #212a35;\n  border-radius: 20px;\n  font-size: 27px;\n}\n\n.icon, font-text {\n  font-size: 30px;\n}\n\n.logoImg {\n  width: 50px;\n}\n\n\ninput[type=\"search\"] {\n  border-radius: 20%;\n  background: transparent;\n  margin: 0;\n  padding: 7px 8px;\n  font-size: 14px;\n  color: inherit;\n  border: 1px solid #c2bfbf;\n  border-radius: inherit;\n}\n\ninput[type=\"search\"]::placeholder {\n  color: #bbb;\n}\n\n.menu__diretoria > li {\n  justify-content: center !important;\n}\n\n.menu__diretoria > a {\n  justify-content: center !important;\n}\n\n/* Upload Axios */\n.axiosUpload input {\n  max-width: 80%;\n  height: 30px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 18px;\n}\n\n.axiosUpload input[type=file] {\n  color: black;\n}\n\n.axiosUpload input[type=file]::file-selector-button {\n  width: 200px;\n  margin-right: 20px;\n  border: none;\n  background: #084cdf;\n  padding: 10px 20px;\n  border-radius: 10px;\n  color: #fff;\n  cursor: pointer;\n  transition: background .2s ease-in-out;\n}\n\n#avatar {\n  border-radius: 5px;\n  margin:  auto; \n  border: none;\n  max-width: 50%;\n}\n\n#btnUpload {\n  width: 200px;\n  height: 35px;\n  border-radius: 5px;\n  background-color: #1859db;\n  color: white;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.banner {\n  position: relative;\n  max-width: 800px;\n  width: 100%;\n  height: 200px;\n  background-image: url(\"https://www.shutterstock.com/image-photo/portrait-happy-business-people-digital-600w-2245070915.jpg\"); \n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: right center;\n  overflow: hidden;\n  border: 10px solid white;\n  margin-top: 30px;\n  margin-left: 50px;\n  border-radius: 16px;\n}\n\n.banner__content {\n  --mask: radial-gradient(300px at 100% 59%,#0000 98%,#000);\n  -webkit-mask: var(--mask);\n          mask: var(--mask);\n  background-color: #001a2c;\n  color: white;\n  width: 800px;\n  height: 200px;\n}\n\n.banner__inner__content {\n  margin-left: 30px;\n  padding-top: 20px;\n}\n\n.banner__title {\n  margin-top: 18px;\n  font-size: 23px;\n}\n\n.people {\n  width: 95%;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.cards {\n    max-width: 900px;\n    align-items: center;\n    width: 90%;\n    margin-left: 20px !important;\n    margin-bottom: 30px !important;\n}\n\n.formdeclaration {\n  padding-left: 0 !important;\n}\n\n.form__logistics {\n   width: 77%;\n   padding-top: 30px;\n   margin-bottom: 30px;\n   height: 100%;\n}\n\n/* cards people  */\n.ag-format-container {\n  width: 100%;\n  margin: 0 auto;\n}\n\n.ag-courses_box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.ag-courses_item {\n  -ms-flex-preferred-size: calc(33.33333% - 30px);\n  flex-basis: calc(33.33333% - 30px);\n  margin: 0 15px 5px;\n  overflow: hidden;\n  border-radius: 28px;\n  min-width: 280px;\n  -webkit-box-shadow: 6px 3px 10px 0px rgba(0,0,0,0.36);\n  -moz-box-shadow: 6px 3px 10px 0px rgba(0,0,0,0.36);\n  box-shadow: 6px 3px 10px 0px rgba(0,0,0,0.36);\n}\n\n.ag-courses-item_link {\n  display: block;\n  padding: 15px 13px;\n  background-color: #003153;\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n}\n\n.ag-courses-item_link:hover,\n.ag-courses-item_link:hover .ag-courses-item_date {\n  text-decoration: none;\n  color: #FFF;\n}\n\n.ag-courses-item_link:hover .ag-courses-item_bg {\n  -webkit-transform: scale(10);\n  -ms-transform: scale(10);\n  transform: scale(10);\n}\n\n.ag-courses-item_title {\n  min-height: 87px;\n  overflow: hidden;\n  font-weight: bold;\n  font-size: 1.3rem;\n  color: #FFF;\n  z-index: 2;\n  position: relative;\n}\n\n.ag-courses-item_bg {\n  height: 128px;\n  width: 128px;\n  background-color: #3ecd5e;\n\n  z-index: 1;\n  position: absolute;\n  top: -75px;\n  right: -75px;\n\n  border-radius: 50%;\n\n  -webkit-transition: all .5s ease;\n  -o-transition: all .5s ease;\n  transition: all .5s ease;\n}\n\n.menu_items_container {\n    border-radius: 10px;\n    padding-bottom: 30px;\n    text-align: center;\n    margin-left: 30px;\n}\n\n/* banner */\n\n.banner1 {\n  position: relative;\n  max-width: 800px;\n  width: 100%;\n  height: 225px;\n  overflow: hidden;\n  margin-top: 25px;\n  margin-left: 80px;\n  border-bottom-left-radius: 16px;\n  border-bottom-right-radius: 16px;\n  border-top-right-radius: 16px;\n}\n\n.banner__content1 {\n  position: relative;\n  background-color: #f5f5dc;\n  width: 800px;\n  height: 300px;\n}\n\n.banner__inner__content1 {\n  margin-left: -30px;\n}\n\n.banner__inner__content1 img {\n  width: 500px;\n}\n\n.banner__intro1 {\n  font-size: 18px;\n}\n\n.banner__title1 {\n  margin-top: 18px;\n  font-size: 23px;\n}\n\n.banner__description1 {\n  margin-top: 20px;\n}\n\n/* navbar */\n.Navbar_nav__gsmxT {\n  align-items: center;\n    background: #fff;\n    border-bottom: 3px solid #9dd354;\n    box-shadow: 0 5px 15px rgba(0,0,0,.06);\n    display: flex;\n    justify-content: space-between;\n    padding: 10px;\n}\n\nsmall {\n  margin-left: 18px;\n}\n\n/* Pagina Consulta de Produtos */\n.css-5gwxe9-MuiContainer-root {\n  padding-bottom: 30px;\n}\n\n.css-1dbovja .MuiTextField-root {\n  min-width: 100% !important;\n}\n\n.css-3be3ve-MuiFormControl-root-MuiTextField-root-MuiDataGrid-toolbarQuickFilter {\n  min-width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
